import React, { useCallback } from 'react';
import { Button, Box } from '@wix/design-system';
import s from './PlanFormLink.scss';
import { navigateTo } from '@wix/business-manager-api';
export const PlanFormLink = _ref => {
  let {
    data: {
      planId
    },
    context: {
      onWidgetAction
    }
  } = _ref;
  const onClick = useCallback(() => {
    onWidgetAction(PRICING_PLANS_FORM_LINK, {
      action: 'open plan form'
    });
    navigateTo({
      pageComponentId: 'PRICING_PLANS.pages.edit',
      contextData: {
        appState: planId,
        referrer: 'pricing-plans-ai-assistant'
      }
    });
  }, [planId, onWidgetAction]);
  return /*#__PURE__*/React.createElement(Box, {
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: onClick,
    className: s.button
  }, "Go to Plan"));
};
export const PRICING_PLANS_FORM_LINK = 'PRICING_PLANS_FORM_LINK';
//# sourceMappingURL=PlanFormLink.js.map